import React from 'react';
import '../styles/profile.css';

const ProfilePage: React.FC = () => {
  return (
    <div className="profile-page">
      <div className="profile-container">
        {/* Hero Section with Image */}
        <div className="profile-hero">
          <div className="profile-image-container">
            <img 
              src="/NatalieNew.png" 
              alt="Natalie Antekelian, Esq." 
              className="profile-image"
            />
          </div>
          <div className="profile-header">
            <h1 className="profile-name">Natalie Antekelian, Esq.</h1>
            <h2 className="profile-title">Founder & Principal Attorney</h2>
            <h3 className="profile-company">Muse Legal Group</h3>
          </div>
        </div>

        {/* Biography Section */}
        <div className="profile-content">
          <div className="profile-section">
            <p className="profile-text">
              Natalie Antekelian is a distinguished personal injury attorney and founder of Muse Legal Group. She had devoted her practice to advocating for injured victims. She focuses her practice on auto, trucking, and rideshare accidents, as well as dog bite cases and slip-and-fall injuries.
            </p>
          </div>

          <div className="profile-section">
            <p className="profile-text">
              Before founding Muse Legal Group, Natalie gained extensive experience at several prominent law firms across Southern California, where she mastered the art of navigating complex legal cases and securing favorable outcomes for her clients. This invaluable experience solidified her reputation as a meticulous, compassionate, and results-driven advocate.
            </p>
          </div>

          <div className="profile-section">
            <h4 className="profile-subtitle">Education</h4>
            <p className="profile-text">
              A proud graduate of the University of California, Los Angeles (UCLA), Natalie earned her bachelor's degree with distinction and was an active member of the Pre-Law Society. Her passion for justice and advocacy led her to pursue her Juris Doctor at Loyola Law School, where she concentrated in civil litigation and refined the skills that would define her legal career.
            </p>
          </div>

          <div className="profile-section">
            <h4 className="profile-subtitle">Our Philosophy</h4>
            <p className="profile-text">
              Natalie established Muse Legal Group with the belief that every client deserves personalized attention, clear communication, and unwavering dedication. She is committed to providing exceptional representation while ensuring that her clients feel supported, informed, and empowered throughout the legal process.
            </p>
          </div>

          <div className="profile-section">
            <h4 className="profile-subtitle">Community Impact</h4>
            <p className="profile-text">
              Beyond her legal practice, Natalie's dedication to making a meaningful impact extends into her community. Her work reflects not only a pursuit of justice but also a genuine care for the individuals and families she serves.
            </p>
          </div>

          {/* CTA Section */}
          <div className="profile-cta-section">
            <h3 className="profile-cta-title">Ready to Discuss Your Case?</h3>
            <p className="profile-cta-text">
              Schedule a free consultation with Natalie today
            </p>
            <div className="profile-cta-buttons">
              <a href="/contact" className="profile-cta-button primary">
                Schedule Consultation
              </a>
              <a href="tel:8182458888" className="profile-cta-button secondary">
                Call (818) 245-8888
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;

